module.exports = {
      id: "icon-overview-clinics-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-overview-clinics",
      toString: function () {
        return this.url;
      }
    }